import { render, staticRenderFns } from "./IncomingLetterIndex.vue?vue&type=template&id=f15f0af0"
import script from "./IncomingLetterIndex.vue?vue&type=script&lang=js"
export * from "./IncomingLetterIndex.vue?vue&type=script&lang=js"
import style0 from "./IncomingLetterIndex.vue?vue&type=style&index=0&id=f15f0af0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports